import { create } from "zustand";
import type { Device } from "../types";

interface DevicesState {
	modalOpen: boolean;
	editingDevice: Device | null;
}

interface DevicesActions {
	openCreateModal: () => void;
	openEditModal: (device: Device) => void;
	closeModal: () => void;
}

type DevicesStore = DevicesState & DevicesActions;

export const useDevicesStore = create<DevicesStore>((set) => ({
	modalOpen: false,
	editingDevice: null,

	openCreateModal: () => {
		set({ modalOpen: true, editingDevice: null });
	},

	openEditModal: (device) => {
		set({ modalOpen: true, editingDevice: device });
	},

	closeModal: () => {
		set({ modalOpen: false, editingDevice: null });
	},
}));
